module.exports = __webpack_public_path__ + "static/media/w-2_33.6326b8fb.png";